



















































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwChip, SwChipGroup } from '@libs-uuif/shared/sw-chip';
import { namespace } from 'vuex-class';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { UnifiedInsightsReportsStoreState } from '.';
const cssPrefix = 'filter-brief';
const reportStoreModule = namespace('UnifiedInsightsReportsStoreModule');

@Component({
  components: {
    SwChip,
    SwChipGroup,
  },
})

export default class FilterBrief extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @reportStoreModule.Mutation
  saveToFilters: VuexMappedMutation<
    UnifiedInsightsReportsStoreState['filterData']
  >;

  @reportStoreModule.State
  filterData: UnifiedInsightsReportsStoreState['filterData'];

  /*
    @desc Returns Chips for report type.
  */
  get reportTypeFilterChips(): Object[] {
    if (this.filterData.reportType) {
      return this.filterData.reportType.map((entry: any) => {
        const label = entry;
        const id = entry;
        return { id, label };
      });
    }
    return [];
  }

  /*
    @desc Returns Chips for status.
  */
  get statusFilterChips(): Object[] {
    if (this.filterData.status) {
      return this.filterData.status.map((entry: any) => {
        const label = entry;
        const id = entry;
        return { id, label };
      });
    }
    return [];
  }

  /*
    @desc Returns chips for delivery method.
  */
  get deliveryMethodFilterChips(): Object[] {
    if (this.filterData.deliveryMethod) {
      return this.filterData.deliveryMethod.map((entry: any) => {
        const label = entry;
        const id = entry;
        return { id, label };
      });
    }
    return [];
  }

  /*
    @desc Returns Chips for product.
  */
  get productFilterChips(): Object[] {
    if (this.filterData.product) {
      return this.filterData.product.map((entry: any) => {
        const label = entry;
        const id = entry;
        return { id, label };
      });
    }
    return [];
  }

  /*
    @desc Removes Chips for report type.
  */
  onRemoveReportTypeFilterChip(id: string) {
    const selected = [...this.filterData.reportType];
    const index = selected.indexOf(id);
    if (index >= 0) {
      selected.splice(index, 1);
    }
    this.saveToFilters({ reportType: selected });
  }

  /*
    @desc Removes Chips for delivery method.
  */
  onRemoveDeliveryMethodFilterChip(id: string) {
    const selected = [...this.filterData.reportType];
    const index = selected.indexOf(id);
    if (index >= 0) {
      selected.splice(index, 1);
    }
    this.saveToFilters({ deliveryMethod: selected });
  }

  /*
    @desc Removes Chips for status.
  */
  onRemoveStatusFilterChip(id: string) {
    const selected = [...this.filterData.reportType];
    const index = selected.indexOf(id);
    if (index >= 0) {
      selected.splice(index, 1);
    }
    this.saveToFilters({ status: selected });
  }

  /*
    @desc Removes Chips for product.
  */
  onRemoveProductFilterChip(id: string) {
    const selected = [...this.filterData.reportType];
    const index = selected.indexOf(id);
    if (index >= 0) {
      selected.splice(index, 1);
    }
    this.saveToFilters({ product: selected });
  }

  /*
    @desc Clears all chips.
  */
  clearAllFilter() {
    const filters = {
      status: [],
      reportType: [],
      deliveryMethod: [],
      product: [],
    };
    this.saveToFilters(filters);
  }
}
